var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 135,
    viewBox: "0 0 251 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_52_11245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5683 61.6176C171.927 78.8164 218.839 43.0387 231 23C198.014 97.8465 149.937 114.169 85.9665 111.781C46.912 110.322 -31.3801 40.1192 81.5683 61.6176Z",
    fill: "url(#paint0_linear_52_11245)",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_52_11245",
    x: 0,
    y: 0,
    width: 254,
    height: 135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5,
    result: "effect1_foregroundBlur_52_11245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_11245",
    x1: 231.399,
    y1: 26.9812,
    x2: 132.856,
    y2: 132.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape04);
export default __webpack_public_path__ + "static/media/shape-04.8a6c6f2eeb68166b72c23b8b89a49068.svg";
export { ForwardRef as ReactComponent };